import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import PrepareDataTable from "./PrepareDataTable";
import AddEditSpecificCondition from "../AddEditSpecificCondition";
import {
  SpecificConditionListContainer,
  Title,
} from "./SpecificConditionList.styled";

import "./SpecificConditionList.scss";

/**
 * Specific Conditions List,
 * Path - /general/specificConditions
 * @see See [specific conditions Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/3089104900/Administration+-+Quotes+specific+conditions)
 * @component
 */
const SpecificConditionList = (props) => {
  const { t, columnList, countries } = props;

  const [isAddConditionPopupVisible, setAddConditionPopupVisible] =
    useState(false);
  const [isRefreshList, setIsRefreshList] = useState(false);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  const createNewCondition = () => {
    setAddConditionPopupVisible(true);
  };
  const closeConditionCreationPopup = () => {
    setAddConditionPopupVisible(false);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  return (
    <SpecificConditionListContainer className="specificCondition-list">
      <Title>{t("QUOTES_SPECIFIC_CONDITIONS")}</Title>
      <PrepareDataTable
        isRefreshList={isRefreshList}
        columnList={columnList}
        updateRefeshStatus={updateRefeshStatus}
        createNewSpecificCondition={createNewCondition}
        countries={countries}
      />
      {isAddConditionPopupVisible && (
        <AddEditSpecificCondition
          title={t("SPECIFIC_CONDITION_NEW")}
          onClose={closeConditionCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
        />
      )}
    </SpecificConditionListContainer>
  );
};

SpecificConditionList.propTypes = {
  t: PropTypes.func.isRequired,
  columnList: PropTypes.arrayOf(PropTypes.string),
};

SpecificConditionList.defaultProps = {
  columnList: [],
};

export default withTranslation()(SpecificConditionList);
